import MfaChallenge from './MfaChallenge';

export default MfaChallenge;
